"use strict";

exports.__esModule = true;
exports.CoreButtonNext = void 0;
var _FocusableHOC = require("./FocusableHoc/FocusableHOC");
var _CoreButtonNext = require("./CoreButtonNext");
const CoreButtonNext = (0, _FocusableHOC.withFocusable)(_CoreButtonNext.CoreButtonNext);
exports.CoreButtonNext = CoreButtonNext;
//# sourceMappingURL=index.js.map